import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";
import SectionHeader from "@/components/SectionHeader";
import { Trash2 } from "lucide-react";

export default function Forum() {
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState("");
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();

  const load = () => api.get("/forum").then((r) => setPosts(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!content.trim()) return;
    setLoading(true);
    try {
      await api.post("/forum", { content });
      setContent("");
      load();
    } finally {
      setLoading(false);
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Usunąć post?")) return;
    await api.delete(`/forum/${id}`);
    load();
  };

  return (
    <div className="max-w-4xl mx-auto px-5 py-12" data-testid="forum-page">
      <SectionHeader title="Forum" />
      <form onSubmit={submit} className="sr-card p-5 mt-10 fade-up" data-testid="forum-form">
        <label className="sr-label">Nowy post</label>
        <textarea
          rows={3}
          value={content}
          onChange={(e) => setContent(e.target.value)}
          className="sr-input"
          placeholder="Co u ciebie, bracie?"
          data-testid="forum-input"
        />
        <div className="mt-3 text-right">
          <button type="submit" className="btn-fire" disabled={loading} data-testid="forum-submit">
            {loading ? "..." : "Opublikuj"}
          </button>
        </div>
      </form>

      <div className="mt-8 space-y-4">
        {posts.map((p) => (
          <article key={p.id} className="sr-card p-5" data-testid={`post-${p.id}`}>
            <div className="flex justify-between items-start gap-3">
              <div>
                <p className="font-display text-base text-[var(--sr-fire-2)]">{p.author_name}</p>
                <p className="text-xs font-nav uppercase tracking-widest" style={{ color: "var(--sr-muted)" }}>
                  {new Date(p.created_at).toLocaleString("pl-PL")}
                </p>
              </div>
              {(user?.id === p.author_id || user?.role === "admin") && (
                <button
                  onClick={() => remove(p.id)}
                  className="text-[var(--sr-muted)] hover:text-red-400"
                  data-testid={`delete-post-${p.id}`}
                >
                  <Trash2 size={16} />
                </button>
              )}
            </div>
            <p className="mt-3 whitespace-pre-wrap" style={{ color: "var(--sr-cream-soft)" }}>{p.content}</p>
          </article>
        ))}
        {posts.length === 0 && <p className="text-center" style={{ color: "var(--sr-muted)" }}>Bądź pierwszym, który napisze.</p>}
      </div>
    </div>
  );
}
